import EmailVerification from "../components/auth/Verify";
import VerifyNavBar from "../components/layout/VerifyNavBar";

const Verify = () => {
    return (
        <div>
            <VerifyNavBar />

            < EmailVerification />
        </div>
        
    );
  };
  
export default Verify;